// Where to go after signing in. Only internal CV-access links are kept, so a
// crafted link can't send someone elsewhere.
const KEY = "postLoginPath";

export const setPostLoginPath = (path) => {
  try {
    sessionStorage.setItem(KEY, path);
  } catch (e) {
    // storage blocked: fall back to the dashboard
  }
};

export const takePostLoginPath = () => {
  try {
    const path = sessionStorage.getItem(KEY) || "";
    sessionStorage.removeItem(KEY);
    return /^\/cv-access\?cv=[A-Za-z0-9]+$/.test(path) ? path : "/";
  } catch (e) {
    return "/";
  }
};
